import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  listsRouteSearchSchema,
  parseListsRouteSearch,
  serializeListsRouteSearch,
} from './listsRouteSearch';
import type { SupplyListsTab } from './model';

export function useListsRouteFilters(tab: SupplyListsTab) {
  const navigate = useNavigate();
  const search = useSearch({ strict: false });
  const filter = parseListsRouteSearch(search);
  const update = (updater: (current: typeof filter) => typeof filter) => {
    void navigate({
      to: `/supply/lists/${tab}`,
      search: (current) =>
        serializeListsRouteSearch(updater(parseListsRouteSearch(listsRouteSearchSchema(current)))),
      replace: true,
    });
  };
  return {
    filter,
    setSearch(searchTerm: string) {
      update((current) => ({ ...current, searchTerm, page: 0 }));
    },
    setPagination(page: number, size: number) {
      update((current) => ({ ...current, page: size === current.size ? page : 0, size }));
    },
  };
}
